import styled from 'styled-components';
import { typography } from '@atlaskit/theme';
/**
 * Provide a styled container for field components
 */

var FieldWrapper = styled.div.withConfig({
  displayName: "Field__FieldWrapper",
  componentId: "vqybw1-0"
})(["\n  margin-top: 8px;\n"]);
/**
 * Provide a styled Label for field components
 */

export var Label = styled.label.withConfig({
  displayName: "Field__Label",
  componentId: "vqybw1-1"
})(["\n  ", " display: inline-block;\n  margin-bottom: 4px;\n  margin-top: 0;\n"], typography.h200());
/**
 * The content that sits below the field
 */

export var HelperText = styled.span.withConfig({
  displayName: "Field__HelperText",
  componentId: "vqybw1-2"
})(["\n  ", " font-weight: normal;\n  margin-top: 8px;\n"], typography.h200());
export default FieldWrapper;